import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AuthGuard } from './shared-services/guards/auth.guard';

import { AnonymousLayoutComponent } from './main/layouts/anonymous/anonymous-layout.component';
import { AuthenticatedLayoutComponent } from './main/layouts/authenticated/authenticated-layout.component';
import { DemoComponent } from './main/demo/demo.component';
import { WelcomeComponent } from './main/welcome/welcome.component';
import { UnauthorizedComponent } from './main/unauthorized/unauthorized.component';
import { StartComponent } from './main/start/start.component';

const anonymousRoutes = [
    { path: '', redirectTo: 'welcome', pathMatch: 'full' },
    { path: 'welcome', component: WelcomeComponent },
    { path: 'unauthorized', component: UnauthorizedComponent },
    { path: 'forbidden', component: UnauthorizedComponent }
];

const authenticatedRoutes = [
    {
        path: 'demo',
        canActivate: [AuthGuard],
        component: DemoComponent
    },
    {
        path: 'start',
        canActivate: [AuthGuard],
        component: StartComponent
    },
    {
        path: 'orders',
        canActivate: [AuthGuard],
        loadChildren: () => import('./orders/orders.module').then(m => m.OrdersModule)
    },
    {
        path: 'products',
        canActivate: [AuthGuard],
        loadChildren: () => import('./products/products.module').then(m => m.ProductsModule)
    },
    {
        path: 'reports',
        canActivate: [AuthGuard],
        loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule)
    },
    {
        path: 'stores',
        canActivate: [AuthGuard],
        loadChildren: () => import('./stores/stores.module').then(m => m.StoresModule)
    },
];

const routes: Routes = [
    { path: '', component: AnonymousLayoutComponent, children: anonymousRoutes },
    { path: '', component: AuthenticatedLayoutComponent, children: authenticatedRoutes },
    { path: '**', redirectTo: 'welcome', pathMatch: 'full' }
];


@NgModule({
    imports: [RouterModule.forRoot(routes, 
        { 
            preloadingStrategy: PreloadAllModules, 
            enableTracing: false, 
            paramsInheritanceStrategy: 'always',
            scrollPositionRestoration: 'enabled',
            onSameUrlNavigation: 'reload'
        })],
    exports: [RouterModule],
})
export class AppRoutingModule { }
